var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.canDisplay)?_c('div',{staticClass:"d-flex align-center justify-space-between"},[_c('v-breadcrumbs',{attrs:{"items":_vm.breadcrumbs},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
return [_c('v-breadcrumbs-item',{attrs:{"to":{
          name: item.to,
        },"disabled":!item.to,"exact":""}},[_c('span',[_vm._v(_vm._s(item.text))])])]}}],null,false,2825645089)})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }